export class PostGetPatientInPersonUrgentCareRequest {
    patientId: string = "";
    fhirPatientID: string = "";
    longitude?: number;
    latitude?: number;
    maxDisplayCount: number = 3;
}